export default __webpack_public_path__ + "static/BG3-526072b710f0b7ec6f39be6476260b91.jpg";